import request from '@/utils/request'
import qs from 'qs'

export function get(data) {
  return request({
    url: '/api/system/Parking/all',
    method: 'get',
    params: data
  })
}

export function add(data) {
  return request({
    url: `/api/system/Parking`,
    method: 'post',
    data: data
  })
}

export function update(id, data) {
  return request({
    url: `/api/system/Parking/${id}`,
    method: 'put',
    data: data
  })
}

export function getInfo(id) {
  return request({
    url: `/api/system/Parking/${id}`,
    method: 'get'
  })
}

export function parkingArea() {
  return request({
    url: '/api/system/ParkingArea',
    method: 'get',
    params:{currentPage:1,pageSize:1000}
  })
}

export function del(uid) {
  return request({
    url: '/api/system/Parking/' + uid,
    method: 'delete'
  })
}

export function downloadMethod(data) {
  return request({
    url: '/api/system/Parking/exportData' + '?' + qs.stringify(data, { skipNulls: true, indices: false }),
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 下载二维码
 * @param {*} data
 * @returns
 */
export function downloadQRCode(data) {
  return request({
    url: '/api/system/Parking/downloadQRCodeBySpace',
    method: 'get',
    params: data
  })
}



/**
 * 打折优惠码
 * @param id
 * @param data
 * @returns {*}
 */
export function bduildGateParkingDiscountQRCode(id, data) {
  return request({
    url: `/api/system/Parking/bduildGateParkingDiscountQRCode/${id}`,
    method: 'get',
    params: data,
    responseType: 'arraybuffer'
  })
}

/**
 * 道闸场内码
 * @param id
 * @param data
 * @returns {*}
 */
export function buildGateParkingQRCode(id, data) {
  return request({
    url: `/api/system/Parking/BuildGateParkingQRCode/${id}`,
    method: 'get',
    params: data,
    responseType: 'arraybuffer'
  })
}
/**
 * 道闸场内码-小程序
 * @param id
 * @param data
 * @returns {*}
 */
export function buildGateParkingWxAppQRCode(data) {
  return request({
    url: '/api/system/ParkingLane/build/wxApplet/qRCode',
    method: 'get',
    params: data,
    responseType: 'arraybuffer'
  })
}
/**
 * 停车场列表
 * @returns
 */
export function parkingList(data) {
  return request({
    url: '/api/system/Parking/all',
    method: 'get',
    params: data
  })
}
export function getCodeByAddress(data) {
  return request({
    url: '/api/system/Base/Area/getCodeByAddress',
    method: 'get',
    params: data
  })
}
/**
 * 获取停车场泊位、车位汇总
 * @returns
 */
export function getParkingSum(data) {
  return request({
    url: '/api/system/Parking/sum',
    method: 'get',
    params: data
  })
}

/**
 * 获取停车场泊位、车位汇总
 * @returns
 */
export function isBindIf(id) {
  return request({
    url: `/api/system/Parking/bindIf/${id}`,
    method: 'get'
  })
}

/**
 * 更新月卡余数
 * @returns
 */
export function refresh(id) {
  return request({
    url: `/api/system/Parking/updateLongRentalSpaceLeave/${id}`,
    method: 'put'
  })
}

/**
 * 更新剩余泊位数
 * @returns
 */
export function refreshSpace(data) {
  return request({
    url: `/api/system/Parking/${data.tenantId}/counter`,
    method: 'get',
    params:data
  })
}

/**
 * 更新剩余泊位数3
 * @returns
 */
export function refreshSpace3(data) {
  return request({
    url: `/api/system/Parking/${data.tenantId}/counter3`,
    method: 'get',
    params:data
  })
}
/**
 * 修改车场剩余泊位数
 * @returns
 */
export function updateFreecnt(param) {
  return request({
    url: `/api/system/Parking/freecnt/${param.id}`,
    method: 'put',
    data:param
  })
}

/**
 * 获取修改剩余泊位日志
 * @returns
 */
export function operlogList(param) {
  return request({
    url: `/api/system/Parking/operlogList`,
    method: 'get',
    params:param
  })
}


/**
 * 消息下发
 * @param {*} data
 * @returns
 */
export function defaultScence(data) {
  return request({
    url: '/api/system/Device/sendScreenMsg/defaultScence',
    method: 'post',
    data
  })
}

/**
 * 模板下载
 * @returns {*}
 */
export function templateDownload() {
  return request({
    url: `/api/system/Parking/templateDownload`,
    method: 'get'
  })
}
/**
 * 导入车场
 * @returns {*}
 */
export function importData(data) {
  const param = new FormData()
  param.append('file', data.file)

  return request({
    url: `/api/system/Parking/importData/${data.type}`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: param
  })
}